export enum UserListTabs {
  Active = 'active',
  Pending = 'pending',
  Inactive = 'inactive',
  Deleted = 'deleted',
}
